import { cva } from 'class-variance-authority';

export const gradient = cva([], {
  variants: {
    style: {
      1: ['bg-gradient-to-b', 'from-primary-2-10', 'to-[#E5E1FE]'],
      2: ['bg-gradient-to-b', 'from-[rgb(0,0,0,0.63)]', 'to-[rgb(0,0,0,0)]'],
      3: ['bg-gradient-to-t', 'from-[rgb(0,0,0,1)]', 'to-[rgb(0,0,0,0)]'],
    },
  },
  defaultVariants: {
    style: 1,
  },
});
